import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "antd";
import { FormattedMessage } from "react-intl";
import Surface from "../../components/layouts/Surface";
import PeriodSelector from "../workDiaries/components/PeriodSelector";
import moment from "moment";
import FullScreenModal from "../../components/templates/FullScreenModal";
import WorkDiary from "../workDiary/index";
import DiariesTable from "./components/DiariesTable";
import jsPDF from "jspdf";
import {
  loadPage,
  setYear,
  setMonth,
  reset,
  sendDiaryToEmployees,
} from "./employeeWorkDiariesSlice";
import { useIntl } from "react-intl";
import { getDiary, loadImage } from "../../components/util/helpers";
import { getFullName } from "../../components/util/helpers";

const WorkDiaries = (props) => {
  const { type, activeTab } = props;
  const dispatch = useDispatch();
  const intl = useIntl();
  const organization = useSelector((state) => state.organization.details);
  const [currentDate, setCurrentDate] = useState(moment());
  const [visible, setVisible] = useState(false);
  const activeEmployee = useSelector(
    (state) => state.employeeDetails.activeEmployee
  );
  const { activeYear, activeMonth } = useSelector(
    (state) => state.employeeWorkDiaries
  );

  const { items } = useSelector((state) => state.employeeWorkDiaries.page);

  useEffect(() => {
    if (
      activeYear &&
      activeMonth &&
      ((activeEmployee.id && activeTab === "employee_work_diaries") ||
        type === "modal")
    ) {
      dispatch(loadPage());
    }
  }, [dispatch, activeYear, activeMonth, activeEmployee.id, activeTab, type]);

  useEffect(() => {
    return function cleanup() {
      dispatch(reset());
    };
  }, []);

  useEffect(() => {
    var month = currentDate ? currentDate.format("M") : null;
    var year = currentDate ? currentDate.format("YYYY") : null;
    dispatch(setMonth({ month: month }));
    dispatch(setYear({ year: year }));
  }, [dispatch, currentDate]);

  const onHideProduce = () => {
    setVisible(false);
  };

  const onNextDate = () => {
    setCurrentDate(moment(currentDate).add(1, "months").startOf("month"));
  };
  const onPreviousDate = () => {
    setCurrentDate(moment(currentDate).subtract(1, "months").startOf("month"));
  };

  const onSendAll = async () => {
    const avatar_url = organization.avatar_url;
    const logo = await loadImage(avatar_url);
    const attachments = [];
    const attachment_names = [];
    const order_ids = [];
    if (items && items.length > 0) {
      items.forEach((item, i) => {
        let diariesPdf = new jsPDF({ orientation: "p" });
        const pdf = getDiary(
          diariesPdf,
          intl,
          item,
          organization,
          currentDate,
          logo
        );
        var base64result = pdf
          .output("datauristring")
          .substr(pdf.output("datauristring").indexOf(",") + 1);
        const fileName = `יומן עבודה_${getFullName(
          item.patient.surename,
          item.patient.first_name
        )}_${moment(currentDate).format("MM/YYYY")}.pdf`;
        attachments.push(base64result);
        attachment_names.push(fileName);
        order_ids.push(item.order.id);
      });
    }

    const params = {
      email: activeEmployee.contact_info.email,
      month: +moment(currentDate).format("M"),
      year: +moment(currentDate).format("YYYY"),
      attachments: attachments,
      attachment_names: attachment_names,
      order_ids: order_ids,
      employeeId: activeEmployee.id,
    };
    dispatch(sendDiaryToEmployees(params));
  };

  const onPrinatAll = async () => {
    const avatar_url = organization.avatar_url;
    const logo = await loadImage(avatar_url);
    let diariesPdf = new jsPDF({ orientation: "p" });
    if (items && items.length > 0) {
      items.forEach((item, i) => {
        if (i > 0) {
          diariesPdf.addPage();
          const last = diariesPdf.getNumberOfPages();
          diariesPdf.setPage(last);
        }
        diariesPdf = getDiary(
          diariesPdf,
          intl,
          item,
          organization,
          currentDate,
          logo
        );
      });
      window.open(diariesPdf.output("bloburl"), "_blank");
    }
  };

  const PrintDiaries = () => (
    <Button
      style={{ margin: "0 10px" }}
      type="primary"
      onClick={onPrinatAll}
      size="large"
    >
      {<FormattedMessage id="app.work_diary.prinatAll" />}
    </Button>
  );

  const SendDiaries = () => (
    <Button
      style={{ margin: "0 10px" }}
      type="text"
      onClick={onSendAll}
      size="large"
    >
      {<FormattedMessage id="app.work_diary.sendAll" />}
    </Button>
  );

  const WorkDiaries = () => (
    <>
      <div
        style={{
          display: "flex",
          width: "100%",
          justifyContent: "space-between",
          paddingBottom: "10px",
        }}
      >
        <PeriodSelector
          currentDate={currentDate}
          onNextDate={onNextDate}
          onPreviousDate={onPreviousDate}
        />
        <div style={{ display: "flex" }}>
          {items && items.length > 0 && <PrintDiaries />}
          {items &&
            items.length > 0 &&
            activeEmployee.contact_info.email &&
            activeEmployee.agree_to_receive_email && <SendDiaries />}
        </div>
      </div>
      <DiariesTable currentDate={currentDate} diaries={items} />
    </>
  );

  return (
    <div>
      {type === "modal" ? (
        <div style={{ paddingTop: "40px" }}>
          <WorkDiaries />
        </div>
      ) : (
        <Surface>
          <WorkDiaries />
        </Surface>
      )}
      <FullScreenModal visible={visible} onHide={onHideProduce}>
        <WorkDiary />
      </FullScreenModal>
    </div>
  );
};

export default WorkDiaries;
